import { ChangeDetectorRef, Directive, Input } from '@angular/core';
import { UnsubscribeOnDestroyAdapter } from '../../../../adapters/unsubscibe-on-destroy.adapter';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogService } from '../../../../../services/dialog/dialog.service';
import { merge } from 'rxjs';
import { SelectOption } from '../../../../inputs/select/model/select-option';
import { UpsertPriceErrors } from '../upsert-price.component';

@Directive({
  selector: '[pscAbstractPricingList]'
})
export abstract class AbstractPricingListDirective extends UnsubscribeOnDestroyAdapter {
  @Input() upsertPriceErrors: UpsertPriceErrors;
  @Input() formGroup: FormGroup;

  timeOptions: SelectOption[] = this.createTimeOptions();
  constructor(
    protected formBuilder: FormBuilder,
    protected dialogService: DialogService,
    protected changeDetectorRef: ChangeDetectorRef,
    ) {
    super();

  }
  get pricingList(): FormArray {
    return this.formGroup.controls['pricingList'] as FormArray;
  }

  priceListElement(index: number) {
    return this.pricingList.at(index) as FormGroup;
  }

  timeSlots(index: number): FormArray {
    return this.priceListElement(index)?.controls['timeSlots'] as FormArray;
  }

  dateFrom(index: number): FormGroup {
    return this.priceListElement(index)?.controls['dateFrom'] as FormGroup;
  }

  dateTo(index: number): FormGroup {
    return this.priceListElement(index)?.controls['dateTo'] as FormGroup;
  }

  addPricing() {
    const group = this.formBuilder.group({
      dateFrom: this.formBuilder.group({
        month: ['', Validators.required],
        date: ['', Validators.required],
      }),
      dateTo: this.formBuilder.group({
        month: ['', Validators.required],
        date: ['', Validators.required],
      }),
      timeSlots: this.formBuilder.array([], Validators.required),
    });
    this.pricingList.push(group);
    this.addTimeSlot(this.pricingList.length - 1);
    this.subs.sink = merge(
      group.controls['dateFrom'].controls.month.valueChanges,
      group.controls['dateFrom'].controls.date.valueChanges,
      group.controls['dateTo'].controls.month.valueChanges,
      group.controls['dateTo'].controls.date.valueChanges,
    ).subscribe(() => {
      this.upsertPriceErrors.datesAreNotAYear = false;
    });
  }
  removePricing(index: number) {
    this.dialogService.openConfirmDialog(() => {
      this.pricingList.removeAt(index);
      this.changeDetectorRef.detectChanges();
    });
  }

  removeTimeslot(pricingListIndex: number, timeslotIndex: number) {
    this.dialogService.openConfirmDialog(() => {
      this.timeSlots(pricingListIndex).removeAt(timeslotIndex);
      this.changeDetectorRef.detectChanges();
    });
  }

  private createTimeOptions(): SelectOption[] {
    const timeArray: SelectOption[] = [];

    for (let hour = 0; hour < 24; hour++) {
      const hourStr = hour.toString().padStart(2, '0');
      timeArray.push({ label: `${ hourStr }:00`, value: `${ hourStr }:00:00` });
    }

    timeArray.push({ label: `23:59`, value: `23:59:59` });
    return timeArray;
  }

  abstract addTimeSlot(index: number);
}
